<template>
  <v-dialog :value="value" persistent fullscreen>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="$emit('input', false)">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title primaty-title class="primay toolbar-dense">
        <span class="white--text">Resumen de Cajas</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-container>
          <v-skeleton-loader
            v-if="loading" ref="skeleton"
            type="table-heading,list-item-two-line, image, card-heading, article,list-item-avatar-three-line, actions,table-tfoot"
            class="mx-auto"
          />
          <v-row v-if="!loading">
            <v-col>
              <v-card>
                <v-card-title>
                  Resumen de Folletos por Local
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-data-table
                        :headers="headers"
                        :items="datosCajas"
                        no-data-text="Sin información de folletos"
                        hide-default-footer
                        disable-pagination
                      >
                        <template #item.nombre="{ item }">
                          <strong>{{ nombreLocal(item) }}</strong>
                        </template>
                      </v-data-table>
                      <span v-if="datosCajas.length > 0">
                        CL: Competencia Lectora | M1: Competencia Matemática 1 | HCSO: Historia y Cs. Sociales | CIEN: Ciencias | M2:
                        Competencia Matemática 2
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="!loading">
            <v-col>
              <v-card>
                <v-card-title>
                  Resumen de otros Materiales por Local
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-data-table
                        :headers="headers2"
                        :items="datosCajas"
                        no-data-text="Sin información de materiales"
                        hide-default-footer
                        disable-pagination
                      >
                        <template #item.nombre="{ item }">
                          <strong>{{ nombreLocal(item) }}</strong>
                        </template>
                      </v-data-table>
                      <span v-if="datosCajas.length > 0">
                        (*) Total de folletos y otros materiales
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="!loading" class="d-flex justify-space-around align-start" style="background-color:white">
        <v-btn color="secondary" @click="$emit('input', false)">
          cerrar
        </v-btn>
        <v-btn color="secondary" class="mb-4" :loading="loadPdfCajas" @click="pdfInfoCajas">
          <v-icon dark>
            file_download
          </v-icon> descargar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import graphql from '../../utils/graphql';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    fase: {
      type: Number,
      default: null
    },
  },
  data:()=> ({
    datosCajas: [],
    loadPdfCajas: false,
    loading: false
  }),
  computed: {
    headers() {
      const item = [
        { text: 'Local', value: 'nombre', class: 'blue-grey lighten-4' },
        { text: 'CL', value: 'local.caja.leng',align:'center', class: 'blue-grey lighten-4' },
        { text: 'M1', value: 'local.caja.mate', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'HCSO', value: 'local.caja.hcso', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'CIEN', value: 'local.caja.cien', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'M2', value: 'local.caja.mate2', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'CL PESD', value: 'local.caja.lengPesd', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'M1 PESD', value: 'local.caja.matePesd', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'HCSO PESD', value: 'local.caja.hcsoPesd', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'CIEN PESD', value: 'local.caja.cienPesd', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'M2 PESD', value: 'local.caja.mate2Pesd', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'TOTAL', value: 'local.caja.total', align: 'center', class: 'blue-grey lighten-4' },
      ];

      return item;
    },
    headers2 () {
      const item = [
        { text: 'Local', value: 'nombre', class: 'blue-grey lighten-4' },
        { text: 'Sanitario', value: 'local.caja.sanitario', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'Materiales', value: 'local.caja.varios', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'Hojas de Respuestas', value: 'local.caja.hojasRespuestas', align: 'center', class: 'blue-grey lighten-4' },
        { text: 'Total General (*)', value: 'local.caja.totalGeneral', align: 'center', class: 'blue-grey lighten-4' },
      ];

      return item
    },
    delegado() {
      return window.DATA.locales[0].usuario;
    }
  },
  async mounted() {
    await this.cargaDatos();
  },
  methods: {
    async cargaDatos() {
      const fspCodigo = this.fase;
      this.loading = true;
      try {
        const query = {
          query: `query getCajas ($username: String!, $fspCodigo: Int!) {
              cajas: cajasByDelegadoFase(username: $username, fspCodigo: $fspCodigo) {
                local {
                  lapCodigo
                  nombre
                  caja {
                    leng
                    mate
                    hcso
                    cien
                    mate2
                    lengPesd
                    matePesd
                    hcsoPesd
                    cienPesd
                    mate2Pesd
                    total
                    sanitario
                    varios
                    hojasRespuestas
                    totalGeneral
                  }
                }
              }
            }`,
            variables: {
              username: this.delegado,
              fspCodigo,
            }
        };
        const { cajas } = await graphql.request(query);
        this.datosCajas = cajas;
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
      this.loading = false;
    },
    nombreLocal(item) {
      return `${item.local.lapCodigo} ${item.local.nombre}`;
    },
    async pdfInfoCajas() {
      this.loadPdfCajas = true;
      try {
        await this.$store.dispatch('session/ensureSession');
        const token = window.localStorage.getItem('token');
        const url = `${process.env.VUE_APP_SERVER_HOST}/api/archivos/info-cajas?token=${token}&fspCodigo=${this.fase}`;
        window.location = url;
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
      this.loadPdfCajas = false;
    }
  },
}
</script>
